import { QueryClient } from '@tanstack/react-query';
import { LoaderFunction, LoaderFunctionArgs } from 'react-router-dom';
import { urlToLocationKey } from '../basic/locationKey';
import { contentQueryOptions } from './contentQuery';
import { ContentResponse } from './types/shared';
import { contentStore, backgroundColorAtom, sidfotContentAtom } from '@/lib/store/Contentstore';
import { BasePageResponse, SidfotResponse } from './types/pages';
import { Bakgrundsfärg } from './types/enums';
import { sidfotQueryOptions } from '../ui/Sidfot/sidfotQuery';

function isBasePageResponse(obj: unknown): obj is BasePageResponse {
  return typeof obj === 'object' && obj !== null && 'bakgrundsfärg' in obj;
}

export const contentLoaderClosure: (queryClient: QueryClient) => LoaderFunction = (queryClient: QueryClient) => {
  const contentLoader: LoaderFunction = async ({ request }: LoaderFunctionArgs) => {
    const locationKeyToLoad = urlToLocationKey(request.url);
    const contentResponse: ContentResponse = await queryClient.ensureQueryData(contentQueryOptions(locationKeyToLoad));

    if (isBasePageResponse(contentResponse.content)) {
      const sidfot: ContentResponse | null = await queryClient.ensureQueryData(sidfotQueryOptions(contentResponse.content.sidfotGuid));

      if (sidfot === null) {
        contentStore.set(sidfotContentAtom, null);
      }
      else {
        const sidfotResponse = sidfot?.content as SidfotResponse;
        contentStore.set(sidfotContentAtom, sidfotResponse);
      }

      contentStore.set(backgroundColorAtom, contentResponse.content.bakgrundsfärg == Bakgrundsfärg.Sekundär);
    }

    return contentResponse;
  };

  return contentLoader;
};
